import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Children, Fragment, memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { layouts, optionTypes, selectionTypes, shapes, sizes, } from './constants';
import { SwatchPickerContext } from './SwatchPickerContext';
const labelSpacing = theme.spacing.x2;
const labelContainerStyles = css `
  margin-bottom: ${labelSpacing};
`;
const selectedSwatchDescriptionStyles = css `
  ${theme.typeStyles.bodyMediumStyles}
  color: ${theme.colors.gray500};
  margin-top: ${labelSpacing};
`;
const defaultProps = {
    label: '',
    layout: layouts.stack,
    onChange: () => { },
    shape: shapes.CIRCLE,
    size: sizes.medium,
    value: '',
};
const SwatchPicker = ({ children, isLoading, label = defaultProps.label, layout = defaultProps.layout, name, onChange = defaultProps.onChange, selectionType, shape = defaultProps.shape, size = defaultProps.size, value = defaultProps.value, }) => {
    // Get label and description from child for single selection variation
    const selectedSwatch = useMemo(() => (selectionType === selectionTypes.single
        ? (Children
            .toArray(children)
            .find((child) => (
        // @ts-ignore 2339
        child.props.value === value)))
        : null), [
        children,
        selectionType,
        value,
    ]);
    const swatchName = useMemo(() => (selectedSwatch
        // @ts-ignore 2339
        ? selectedSwatch.props.displayName
        : ''), [
        selectedSwatch,
    ]);
    const swatchDescription = useMemo(() => (selectedSwatch
        // @ts-ignore 2339
        ? selectedSwatch.props.description
        : ''), [
        selectedSwatch,
    ]);
    const isLabelVisible = useMemo(() => (selectionType === selectionTypes.single
        && label), [
        label,
        selectionType,
    ]);
    const swatchesContainerStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        ${layout !== 'custom' && css `
          column-gap: ${theme.spacing.x2};
          display: flex;
          row-gap: ${theme.spacing.x2};
        `}
        ${layout === 'scroll' && css `
          flex-wrap: nowrap;
          overflow-x: auto;

          ${theme.media.lessThan('small')(styleUtils.hiddenScrollbarStyles)}
        `}
        ${layout === 'stack' && css `
          flex-wrap: wrap;
        `}
      `), [
        layout,
    ]);
    const providerValue = useMemo(() => ({
        isLoading,
        name,
        onChange,
        optionType: optionTypes[selectionType],
        selectedSwatches: value,
        shape,
        size,
    }), [
        isLoading,
        name,
        onChange,
        selectionType,
        shape,
        size,
        value,
    ]);
    return (_jsxs(Fragment, { children: [isLabelVisible
                && (_jsxs("div", Object.assign({ css: labelContainerStyles, "data-test-ref": "swatch-picker-label" }, { children: [_jsxs("span", Object.assign({ css: theme.typeStyles.titleMediumStyles }, { children: [label, ': '] })), _jsx("span", Object.assign({ css: theme.typeStyles.bodyMediumStyles }, { children: swatchName }))] }))), _jsx("div", Object.assign({ "data-test-ref": "swatch-picker-picker" }, { children: _jsx(SwatchPickerContext.Provider, Object.assign({ value: providerValue }, { children: _jsx("div", Object.assign({ css: swatchesContainerStyles }, { children: children })) })) })), swatchDescription
                && (_jsx("div", Object.assign({ css: selectedSwatchDescriptionStyles, "data-test-ref": "swatch-picker-description" }, { children: swatchDescription })))] }));
};
const MemoizedSwatchPicker = memo(SwatchPicker);
export { MemoizedSwatchPicker as SwatchPicker };
// MC-1068 Temporary hack for Storybook.
export default SwatchPicker;
